import * as angular from 'angular';
import { v4 as uuid } from 'uuid';
import { isLocalhost } from 'data/http';
import { ChannelsFeatures } from '../ChannelsFeatures';
import { ChannelsNames } from '../Channels';
//Disconnect Channel
import { DisconnectModalController } from './disconnectChannel/DisconnectModalController';
import DisconnectModalView from './disconnectChannel/DisconnectModalView.html';
// Styles
import './WhatsAppDpr.scss';
// Controllers
import { ChannelBaseController } from '../ChannelBaseController';
// Constants
import { CHANNEL_CONFIGURATION_WHATSAPP_TAB_ITEM_CONFIGURATIONS_CLICKED, CHANNEL_CONFIGURATION_WHATSAPP_QUICK_REPLY_SWITCH_CLICKED, CHANNEL_CONFIGURATION_WHATSAPP_QUICK_REPLY_DOCUMENTATION_CLICKED, CHANNEL_CONFIGURATION_WHATSAPP_MENU_SWITCH_CLICKED, CHANNEL_CONFIGURATION_WHATSAPP_AUTH_MEDIA_SWITCH_CLICKED, CHANNEL_CONFIGURATION_WHATSAPP_MENU_DOCUMENTATION_CLICKED, } from '../ChannelsSegmentEvents';
const ConfigurationState = [
    'enterprise',
    'phoneNumber',
    'profile',
];
const containsOnlyNumbersRegex = new RegExp(/^\d+$/); // eslint-disable-line no-useless-escape
const containsNumberRegex = new RegExp(/[\d]+/); // eslint-disable-line no-useless-escape
const containsLetterRegex = new RegExp(/[A-Za-z]+/); // eslint-disable-line no-useless-escape
const pinCodeMask = '******';
export class WhatsAppControllerDpr extends ChannelBaseController {
    static $inject = ['$window', 'ApplicationService2', 'application', 'LoadingService', 'ModalService', 'ChannelsSegmentService', 'WhatsAppServiceDpr', 'WhatsAppService', 'WizardHandler', '$translate', 'TranslateService', 'BlipToastService', 'ChannelsService', '$timeout'];
    constructor($window, ApplicationService2, application, LoadingService, ModalService, ChannelsSegmentService, WhatsAppServiceDpr, WhatsAppService, WizardHandler, $translate, TranslateService, BlipToastService, ChannelsService, $timeout) {
        'ngInject';
        super(ChannelsNames.WhatsApp, ChannelsService, ApplicationService2, application);
        this.$window = $window;
        this.ApplicationService2 = ApplicationService2;
        this.application = application;
        this.LoadingService = LoadingService;
        this.ModalService = ModalService;
        this.ChannelsSegmentService = ChannelsSegmentService;
        this.WhatsAppServiceDpr = WhatsAppServiceDpr;
        this.WhatsAppService = WhatsAppService;
        this.WizardHandler = WizardHandler;
        this.$translate = $translate;
        this.TranslateService = TranslateService;
        this.BlipToastService = BlipToastService;
        this.ChannelsService = ChannelsService;
        this.$timeout = $timeout;
        this.isWhatsAppUsingConfigurationsService = false;
        this.isWhatsappAuthenticatedMediaEnabled = false;
        this.isReplyButtonEnabled = false;
        this.isListMessageEnabled = false;
        this.isAuthenticatedMedia = false;
        this.OnSwitchChangeReplyButton = async (event) => {
            this.$timeout(async () => {
                if (event.detail.checked === this.isReplyButtonEnabled) {
                    return;
                }
                const configuration = {
                    IsReplyButtonEnabled: event.detail.checked,
                };
                const trackingConfiguration = {
                    isCloudApiEnabled: false,
                };
                const changed = await this.WhatsAppService.
                    saveConfigurationComponentAndCreateTracking(this.application, event, CHANNEL_CONFIGURATION_WHATSAPP_QUICK_REPLY_SWITCH_CLICKED, configuration, trackingConfiguration);
                if (changed) {
                    this.isReplyButtonEnabled = event.detail.checked;
                }
                else {
                    this.changeSwitchReplyElementValue(!event.detail.checked);
                }
            }, 300);
        };
        this.OnSwitchChangeMenu = async (event) => {
            this.$timeout(async () => {
                if (event.detail.checked === this.isListMessageEnabled) {
                    return;
                }
                const configuration = {
                    IsListMessageEnabled: event.detail.checked,
                };
                const trackingConfiguration = {
                    isCloudApiEnabled: false,
                };
                const changed = await this.WhatsAppService.
                    saveConfigurationComponentAndCreateTracking(this.application, event, CHANNEL_CONFIGURATION_WHATSAPP_MENU_SWITCH_CLICKED, configuration, trackingConfiguration);
                if (changed) {
                    this.isListMessageEnabled = event.detail.checked;
                }
                else {
                    this.changeSwitchMenuElementValue(!event.detail.checked);
                }
            }, 300);
        };
        this.onSwitchChangeAuthMedia = async (event) => {
            this.$timeout(async () => {
                if (event.detail.checked === this.isAuthenticatedMedia) {
                    return;
                }
                const configuration = {
                    IsAuthenticatedMedia: event.detail.checked,
                };
                const trackingConfiguration = {
                    isCloudApiEnabled: false,
                };
                const changed = await this.WhatsAppService.
                    saveConfigurationComponentAndCreateTracking(this.application, event, CHANNEL_CONFIGURATION_WHATSAPP_AUTH_MEDIA_SWITCH_CLICKED, configuration, trackingConfiguration);
                if (changed) {
                    this.isAuthenticatedMedia = event.detail.checked;
                }
                else {
                    this.changeSwitchAuthMediaElementValue(!event.detail.checked);
                }
            }, 300);
        };
        this.trackDocumentationQuickReply = async () => {
            const configuration = {
                isCloudApiEnabled: false,
            };
            await this.WhatsAppService.
                createTrackingFlow(this.application, CHANNEL_CONFIGURATION_WHATSAPP_QUICK_REPLY_DOCUMENTATION_CLICKED, configuration);
        };
        this.trackDocumentationMenu = async () => {
            const configuration = {
                isCloudApiEnabled: false,
            };
            await this.WhatsAppService.
                createTrackingFlow(this.application, CHANNEL_CONFIGURATION_WHATSAPP_MENU_DOCUMENTATION_CLICKED, configuration);
        };
        this.onTabItemClicked = async () => {
            const configuration = {
                isCloudApiEnabled: false,
            };
            await this.WhatsAppService.
                createTrackingFlow(this.application, CHANNEL_CONFIGURATION_WHATSAPP_TAB_ITEM_CONFIGURATIONS_CLICKED, configuration);
        };
        this.updateExtraMessageStatus = (event) => {
            if (event) {
                this.account.extras['#wa.about'] = event.detail.value;
            }
        };
        this.updateExtraDescription = (event) => {
            if (event) {
                this.account.extras['#wa.description'] = event.detail.value;
            }
        };
        this.updateCountryCode = (event) => {
            if (event) {
                this.configuration.CountryCode = event.detail.value;
            }
        };
        this.updatePhoneNumber = (event) => {
            if (event) {
                this.configuration.PhoneNumber = event.detail.value;
            }
        };
        this.updateVNameCertificate = (event) => {
            if (event) {
                this.configuration.VNameCertificate = event.detail.value;
            }
        };
        this.updateHasPinCode = (event) => {
            if (event) {
                this.pincodeRegInput = event.detail.value;
            }
        };
        this.updatePassword = (event) => {
            if (event) {
                this.configuration.Password = event.detail.value;
            }
        };
        this.updateWebAppHostName = (event) => {
            if (event) {
                this.configuration.WebAppHostName = event.detail.value;
            }
        };
        this.updatePortInput = (event) => {
            if (event) {
                this.portInput = event.detail.value;
            }
        };
        this.updateUserName = (event) => {
            if (event) {
                this.configuration.UserName = event.detail.value;
            }
        };
        this.updateRegistrationCodeInput = (event) => {
            if (event) {
                this.registrationCodeInput = event.detail.value;
            }
        };
        this.updateupdatePincodeAccInput = (event) => {
            if (event) {
                this.pincodeAccInput = event.detail.value;
            }
        };
        this.updateAccountAddress = (event) => {
            if (event) {
                this.account.address = event.detail.value;
            }
        };
        this.updateAccountEmail = (event) => {
            if (event) {
                this.account.email = event.detail.value;
            }
        };
        this.updateAccountWebsites = (event) => {
            if (event) {
                this.account.extras['#wa.websites'] = event.detail.value;
            }
        };
        this.setRadioButtonHasPinCode = (event) => {
            if (event.detail?.checked) {
                if (event.target?.id == 'yes-button') {
                    this.configuration.HasPincode = 'True';
                }
                else if (event.target?.id == 'no-button') {
                    this.configuration.HasPincode = 'False';
                }
            }
        };
        this.setRadioButtonSmsVoice = (event) => {
            if (event.detail?.checked) {
                if (event.target?.id == 'sms-button') {
                    this.configuration.Method = 'sms';
                }
                else if (event.target?.id == 'voice-button') {
                    this.configuration.Method = 'voice';
                }
            }
        };
        if (this.isNew) {
            this.isActive = false;
        }
        this._init();
    }
    async _init() {
        try {
            this.LoadingService.startLoading();
            this.ChannelsSegmentService.setApplication(this.application);
            this.initializeConfiguration();
            if (!await ChannelsFeatures.isWhatsAppEmbedSignupDisable()) {
                return;
            }
            await this.loadConfiguration();
            await this.checkFeatures();
            await this.ChannelsService.init(this.application);
            this.isActive = this.ChannelsService.isChannelActive(ChannelsNames.WhatsApp);
            if (this.isActive) {
                await this.loadAccountProfile();
            }
        }
        catch (err) {
            if (err.code != 67) {
                await this.toastError(13);
            }
        }
        finally {
            const index = ConfigurationState.indexOf(this.configuration.CurrentState);
            this.currentStateIndex = (index < 0) ? 0 : index;
            this.jumpToStep(this.currentStateIndex);
            this.LoadingService.stopLoading();
        }
        this.configurationCopy = angular.copy(this.configuration);
    }
    initializeConfiguration() {
        this.configuration = {
            AccountExternalId: uuid(),
            WebAppHostName: '',
            WebAppPort: '',
            UserName: '',
            Password: '',
            CountryCode: '',
            PhoneNumber: '',
            Method: '',
            VNameCertificate: '',
            CurrentState: ConfigurationState[0],
            ValidPhone: false,
            HasPincode: '',
            Shards: '',
        };
        this.currentStateIndex = 0;
        this.portInput = undefined;
        this.pincodeRegInput = undefined;
        this.pincodeAccInput = undefined;
        this.registrationCodeInput = undefined;
        this.account = {
            address: '',
            email: '',
            photoUri: undefined,
            extras: {
                '#wa.description': '',
                '#wa.websites': '',
                '#wa.vertical': '',
                '#wa.about': '',
            },
        };
    }
    //Do NOT use this function to advance from phone number to registration code part
    async advanceConfiguration() {
        try {
            if (this.currentStateIndex < (ConfigurationState.length - 1)) {
                this.currentStateIndex += 1;
            }
            this.configuration.CurrentState = ConfigurationState[this.currentStateIndex];
            await this.submitConfiguration();
            this.advanceWizard();
        }
        catch (err) {
            console.error(err); // eslint-disable-line no-console
            if (err.code != 67) {
                await this.toastError(13);
            }
        }
    }
    advanceWizard() {
        this.WizardHandler.wizard().next();
    }
    //Do NOT use this function to return from registration code to phone number part
    async goBackConfiguration() {
        try {
            if (this.currentStateIndex > 0) {
                this.currentStateIndex -= 1;
            }
            this.configuration.CurrentState = ConfigurationState[this.currentStateIndex];
            await this.submitConfiguration();
            this.goBackWizard();
        }
        catch (err) {
            console.error(err); // eslint-disable-line no-console
            if (err.code != 67) {
                await this.toastError(13);
            }
        }
    }
    goBackWizard() {
        this.WizardHandler.wizard().previous();
    }
    isStateEquals(index) {
        return (ConfigurationState[index] === this.configuration.CurrentState);
    }
    jumpToStep(index = 0) {
        if (this.WizardHandler && this.WizardHandler.wizard()) {
            const stepTotal = this.WizardHandler.wizard().totalStepCount();
            if (index >= stepTotal) {
                index = stepTotal - 1;
            }
            this.WizardHandler.wizard().goTo(index);
        }
    }
    jumpToContentTab(index = 0) {
        const tabID = `content-tab-${index}`;
        const tab = document.getElementById(tabID);
        setTimeout(() => {
            tab.dispatchEvent(new Event('click'));
        });
    }
    async loadConfiguration() {
        try {
            const configuration = await this.WhatsAppServiceDpr.getConfiguration(this.isConfigurationsApplicationsDomainUsageGetEnabled);
            if (configuration) {
                configuration.ValidPhone = (configuration.ValidPhone && configuration.ValidPhone == 'True') ? true : false;
                this.pincodeAccInput = (configuration.HasPincode === 'True') ? pinCodeMask : '';
                this.portInput = configuration.WebAppPort ? parseInt(configuration.WebAppPort, 10) : undefined;
                this.isReplyButtonEnabled = configuration.IsReplyButtonEnabled === 'True';
                this.changeSwitchReplyElementValue(this.isReplyButtonEnabled);
                this.isListMessageEnabled = configuration.IsListMessageEnabled === 'True';
                this.changeSwitchMenuElementValue(this.isListMessageEnabled);
                this.isAuthenticatedMedia = configuration.IsAuthenticatedMedia === 'True';
                this.changeSwitchAuthMediaElementValue(this.isAuthenticatedMedia);
                this.configuration = { ...this.configuration, ...configuration };
            }
        }
        catch (err) {
            if (err.code != 67) {
                throw err;
            }
        }
    }
    async loadAccountProfile() {
        try {
            const account = await this.WhatsAppServiceDpr.getAccountProfile();
            if (account) {
                this.account = account;
            }
        }
        catch (err) {
            switch (true) {
                case (err.code === 67 && err.description.includes('Could not find business profile')):
                    break;
                default: {
                    if (err.code === 81 && this.isActive) {
                        const message = this.$translate.instant('whatsapp.deprecated.infoMsg.1');
                        const buttonText = this.$translate.instant('updateService.buttonText');
                        const callback = () => {
                            location.reload();
                        };
                        this.BlipToastService.show('refresh', {
                            msg: message,
                            callback,
                            buttonText,
                        });
                    }
                    else {
                        throw err;
                    }
                    break;
                }
            }
        }
    }
    async submitConfiguration() {
        this.LoadingService.startLoading();
        try {
            this.configuration.WebAppPort = this.portInput ? `${this.portInput}` : '';
            await this.WhatsAppServiceDpr.setConfiguration(this.configuration, this.isConfigurationsApplicationsDomainUsageSetEnabled);
        }
        catch (err) {
            console.error(err); // eslint-disable-line no-console
            if (err.code != 67) {
                await this.toastError(3);
            }
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async deleteConfiguration() {
        try {
            await this.WhatsAppServiceDpr.deleteConfiguration(this.isConfigurationsApplicationsDomainUsageSetEnabled);
        }
        catch (err) {
            console.error(err); // eslint-disable-line no-console
            if (err.code != 67) {
                await this.toastError(3);
            }
        }
    }
    async submitURLConfiguration() {
        if (!this.validateURLConfiguration()) {
            return;
        }
        try {
            this.LoadingService.startLoading();
            await this.advanceConfiguration();
            this.afterUpdateConfiguration();
        }
        catch (err) {
            console.error(err); // eslint-disable-line no-console
            if (err.code != 67) {
                await this.toastError(3);
            }
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    validateURLConfiguration() {
        const hostname = this.configuration.WebAppHostName;
        const port = this.portInput;
        const userName = this.configuration.UserName;
        const password = this.configuration.Password;
        if ((!hostname || hostname.length == 0) ||
            (!port) ||
            (!userName || userName.length == 0) ||
            (!password || password.length == 0)) {
            this.toastError(2);
            return false;
        }
        try {
            if (isLocalhost(hostname.includes('//') ? hostname : `https://${hostname}`)) {
                this.toastError(18);
                return false;
            }
        }
        catch (e) {
            this.toastError(5);
            return false;
        }
        return true;
    }
    async submitPhoneNumberConfiguration() {
        if (!this.validatePhoneNumberConfiguration()) {
            return;
        }
        try {
            this.LoadingService.startLoading();
            const pincode = (this.configuration.HasPincode === 'True') ? this.pincodeRegInput : undefined;
            const phoneNumberConfiguration = {
                countryCode: this.configuration.CountryCode,
                phoneNumber: this.configuration.PhoneNumber,
                method: this.configuration.Method,
                vNameCertificate: this.configuration.VNameCertificate,
                pincode: pincode,
            };
            await this.WhatsAppServiceDpr.setPhoneNumberConfiguration(phoneNumberConfiguration);
            await this.checkAccountProfile();
            this.afterUpdateConfiguration();
        }
        catch (err) {
            console.error(err); // eslint-disable-line no-console
            if (err.description.includes('two-step') || err.description.includes('Bad code')) {
                await this.toastError(15);
            }
            else if (err.description.includes('There was an error verifying this phone number')) {
                await this.toastError(22);
            }
            else if (err.code === 64 && err.description.includes('A phone number can only be connected to one chatbot at a time')) {
                this.BlipToastService.show('danger', {
                    title: await this.$translate('whatsapp.errorMsg.phoneNumberIsAlreadyConnected.title'),
                    msg: await this.$translate('whatsapp.errorMsg.phoneNumberIsAlreadyConnected.msg') + err.description,
                });
            }
            else if (err.code != 67) {
                await this.toastError(12);
            }
            else {
                await this.toastError(20);
            }
            this.LoadingService.stopLoading();
        }
    }
    checkAccountProfile() {
        return new Promise(async (resolve, reject) => {
            setTimeout(async () => {
                try {
                    await this.loadAccountProfile();
                    this.resolveCheckAccountProfile(true);
                    resolve();
                }
                catch (err) {
                    console.error(err); // eslint-disable-line no-console
                    this.resolveCheckAccountProfile(false);
                    reject();
                }
            }, 5000);
        });
    }
    async resolveCheckAccountProfile(accountExists) {
        try {
            if (accountExists) {
                await this.activateChannel();
            }
            else {
                this.configuration.ValidPhone = true;
                await this.submitConfiguration();
            }
        }
        catch (err) {
            console.error(err); // eslint-disable-line no-console
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    validatePhoneNumberConfiguration() {
        const countryCode = this.configuration.CountryCode;
        const phoneNumber = this.configuration.PhoneNumber;
        const vNameCert = this.configuration.VNameCertificate;
        const pincode = this.pincodeRegInput;
        const hasPincode = this.configuration.HasPincode;
        const method = this.configuration.Method;
        if ((!countryCode || countryCode.length == 0) ||
            (!phoneNumber || phoneNumber.length == 0) ||
            (!vNameCert || vNameCert.length == 0) ||
            !hasPincode || !method) {
            this.toastError(2);
            return false;
        }
        if (this.configuration.HasPincode === 'True') {
            if (!pincode || pincode.length == 0) {
                this.toastError(2);
                return false;
            }
            else if (pincode.length != 6 || !pincode.match(containsOnlyNumbersRegex)) {
                this.toastError(10);
                return false;
            }
        }
        if (!countryCode.match(containsOnlyNumbersRegex)) {
            this.toastError(6);
            return false;
        }
        if (phoneNumber.match(containsLetterRegex) || !phoneNumber.match(containsNumberRegex)) {
            this.toastError(7);
            return false;
        }
        return true;
    }
    async activateChannel() {
        this.isActive = true;
        try {
            try {
                await this.loadAccountProfile();
            }
            finally {
                await this.advanceConfiguration();
                if (this.isWhatsAppUsingConfigurationsService) {
                    this.configuration.IsChannelActive = true;
                    await this.submitConfiguration();
                }
                this.toastSuccess(1);
            }
        }
        catch (err) {
            console.error(err); // eslint-disable-line no-console
            if (err.code != 67) {
                this.toastError(14);
            }
        }
    }
    async submitRegistrationCode() {
        if (!this.validateRegistrationCode()) {
            return;
        }
        try {
            this.LoadingService.startLoading();
            await this.WhatsAppServiceDpr.verifyPhoneNumber(this.registrationCodeInput);
            await this.activateChannel();
            this.afterUpdateConfiguration();
        }
        catch (err) {
            if (err.description.startsWith('Access denied: Please wait')) {
                this.BlipToastService.show('danger', {
                    msg: err.description,
                });
            }
            else {
                await this.toastError(3);
            }
            console.error(err); // eslint-disable-line no-console
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    validateRegistrationCode() {
        const registrationCode = this.registrationCodeInput;
        if ((!registrationCode || registrationCode.length == 0)) {
            this.toastError(2);
            return false;
        }
        if (!registrationCode.match(containsOnlyNumbersRegex) || (registrationCode.length > 0 && registrationCode.length < 6)) {
            this.toastError(11);
            return false;
        }
        return true;
    }
    async submitAccountProfile() {
        if (!this.validateAccountProfile()) {
            return;
        }
        if (this.application.imageUri) {
            this.account.photoUri = this.application.imageUri;
        }
        this.LoadingService.startLoading();
        try {
            if (this.configuration.HasPincode !== 'True') {
                await this.WhatsAppServiceDpr.setPhoneNumberPincode(this.pincodeAccInput);
                this.configuration.HasPincode = 'True';
                await this.submitConfiguration();
            }
            delete this.account.extras['#wa.vertical'];
            await this.WhatsAppServiceDpr.setAccountProfile(this.account);
            if (this.configuration.HasPincode !== 'True' ||
                (this.pincodeAccInput && this.pincodeAccInput !== pinCodeMask)) {
                await this.configureShards();
            }
            this.isActive = true;
            this.afterUpdateConfiguration();
            this.pincodeAccInput = (this.configuration.HasPincode === 'True') ? pinCodeMask : '';
            this.toastSuccess(2);
        }
        catch (err) {
            console.error(err); // eslint-disable-line no-console
            if (err.code != 67) {
                if (err.description.includes('must be an http or https url')) {
                    await this.toastError(19);
                }
                else if (err.description.includes('Wacore is not instantiated')) {
                    await this.toastError(21);
                }
                else {
                    if (this.TranslateService.getCurrentLanguage() == 'en') {
                        this.BlipToastService.show('danger', {
                            msg: err.description,
                        });
                    }
                    else {
                        const messageBase = await this.$translate('whatsapp.deprecated.errorMsg.20');
                        this.BlipToastService.show('danger', {
                            title: messageBase,
                            msg: err.description,
                        });
                    }
                }
            }
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    validateAccountProfile() {
        const about = this.account.extras['#wa.about'];
        const description = this.account.extras['#wa.description'];
        const pincode = this.pincodeAccInput;
        if (this.configuration.HasPincode !== 'True') {
            if (!pincode) {
                this.toastError(16);
                return false;
            }
            else if (pincode.length != 6 || !pincode.match(containsOnlyNumbersRegex)) {
                this.toastError(10);
                return false;
            }
        }
        if (!about || about.trim().length == 0) {
            this.toastError(8);
            return false;
        }
        if (!description || description.trim().length == 0) {
            this.toastError(9);
            return false;
        }
        return true;
    }
    editPincode() {
        this.configuration.HasPincode = 'False';
        this.pincodeAccInput = '';
    }
    async configureShards() {
        try {
            const healthResponse = await this.WhatsAppServiceDpr.getHealth();
            const coreAppsCount = Object
                .keys(healthResponse.health)
                .map(k => healthResponse.health[k])
                .filter(h => h.role == 'coreapp')
                .length;
            const expectedShardsCount = parseInt(this.configuration.Shards) || this.previousPowerOf2(coreAppsCount);
            const shardsResponse = await this.WhatsAppServiceDpr.getShards();
            const currentShardsCount = shardsResponse.account.shards;
            if (expectedShardsCount > 0 &&
                expectedShardsCount != currentShardsCount) {
                await this.WhatsAppServiceDpr.setShards({
                    countryCode: this.configuration.CountryCode,
                    phoneNumber: this.configuration.PhoneNumber,
                    pincode: this.pincodeAccInput,
                    shards: expectedShardsCount,
                    vNameCertificate: this.configuration.VNameCertificate,
                });
            }
        }
        catch (err) {
            console.error('Error configuring container shards', err); // eslint-disable-line no-console
        }
    }
    previousPowerOf2(x) {
        x = x | (x >> 1);
        x = x | (x >> 2);
        x = x | (x >> 4);
        x = x | (x >> 8);
        x = x | (x >> 16);
        return x - (x >> 1);
    }
    async deleteForm(disconnect) {
        try {
            this.disconnect = disconnect;
            await this.deleteConfiguration();
            this.initializeConfiguration();
            this.WizardHandler.wizard().goTo(0);
            this.WizardHandler.wizard().reset();
            this.isActive = false;
            this.disconnectConfirmTracking(true);
            this.toastSuccess(3);
        }
        catch (err) {
            this.disconnectConfirmTracking(false);
            if (err.code != 67) {
                await this.toastError(23);
            }
        }
    }
    async toastError(n) {
        let title;
        let errorMsg;
        if (n === 4 || n === 23) {
            title = await this.$translate(`whatsapp.deprecated.errorMsg.${n}.title`);
            errorMsg = await this.$translate(`whatsapp.deprecated.errorMsg.${n}.msg`);
        }
        else {
            errorMsg = await this.$translate(`whatsapp.deprecated.errorMsg.${n}`);
        }
        this.BlipToastService.show('danger', {
            title,
            msg: errorMsg,
        });
    }
    async toastSuccess(n) {
        let title;
        let successMsg;
        if (n === 1) {
            title = await this.$translate(`whatsapp.deprecated.successMsg.${n}.title`);
            successMsg = await this.$translate(`whatsapp.deprecated.successMsg.${n}.msg`);
        }
        else {
            successMsg = await this.$translate(`whatsapp.deprecated.successMsg.${n}`);
        }
        this.BlipToastService.show('success', {
            title,
            msg: successMsg,
        });
    }
    afterUpdateConfiguration() {
        const addedFields = this.checkAddedFields(this.configuration, this.configurationCopy);
        const changedFileds = this.checkChangedFields(this.configuration, this.configurationCopy, addedFields);
        if (addedFields.length > 0) {
            this.trackConnectionWhatsappConfigurationAddsSaved(addedFields);
        }
        if (changedFileds.length > 0) {
            this.trackConnectionWhatsappConfigurationChangesSaved(changedFileds);
        }
        this.configurationCopy = angular.copy(this.configuration);
    }
    // Segment
    trackConnectionWhatsappConfigurationAddsSaved(addedFields) {
        this.ChannelsSegmentService
            .trackConnectionWhatsappConfigurationAddsSaved({
            AddedFileds: addedFields,
        });
    }
    trackConnectionWhatsappConfigurationChangesSaved(changedFields) {
        this.ChannelsSegmentService
            .trackConnectionWhatsappConfigurationChangesSaved({
            ChangedFields: changedFields,
        });
    }
    async checkFeatures() {
        this.isWhatsAppUsingConfigurationsService = await ChannelsFeatures.isChannelUsingConfigurationsServiceEnabled(ChannelsNames.WhatsApp);
        this.isWhatsappAuthenticatedMediaEnabled = await ChannelsFeatures.isWhatsappAuthenticatedMediaEnabled();
    }
    async showDisconnectChannelModal() {
        try {
            this.disconnectClickedTracking();
            this.disconnect = { text: undefined, agree: undefined };
            await this.ModalService.showModal({
                template: DisconnectModalView,
                controller: DisconnectModalController,
                controllerAs: '$ctrl',
                inputs: {
                    onDeleteForm: this.deleteForm.bind(this),
                    model: this.disconnect,
                },
            });
        }
        catch (err) {
            await this.toastError(1);
        }
    }
    disconnectClickedTracking() {
        this.ChannelsSegmentService
            .disconnectWhatsAppTrack();
    }
    disconnectConfirmTracking(status) {
        this.ChannelsSegmentService
            .disconnectWhatsAppConfirmedTrack({
            text: this.disconnect.text,
            agree: this.disconnect.agree,
        }, status);
    }
    openDocumentation() {
        this.$window.open('https://help.blip.ai/hc/pt-br/sections/4403752619415-WhatsApp', '_blank');
    }
    openWhatsApp() {
        this.$window.open(`https://wa.me/${this.channel.configurations.CountryCode}${this.channel.configurations.PhoneNumber}`, '_blank', 'noopener noreferrer');
    }
    getSwitchReplyElement() {
        return document.getElementById('switchReplyButton');
    }
    getSwitchMenuElement() {
        return document.getElementById('switchMenu');
    }
    getSwitchAuthMediaElement() {
        return document.getElementById('switchAuthMedia');
    }
    changeSwitchReplyElementValue(checked) {
        const element = this.getSwitchReplyElement();
        if (element) {
            element.checked = checked;
        }
    }
    changeSwitchMenuElementValue(checked) {
        const element = this.getSwitchMenuElement();
        if (element) {
            element.checked = checked;
        }
    }
    changeSwitchAuthMediaElementValue(checked) {
        const element = this.getSwitchAuthMediaElement();
        if (element) {
            element.checked = checked;
        }
    }
}
WhatsAppControllerDpr.$inject = ['$window', 'ApplicationService2', 'application', 'LoadingService', 'ModalService', 'ChannelsSegmentService', 'WhatsAppServiceDpr', 'WhatsAppService', 'WizardHandler', '$translate', 'TranslateService', 'BlipToastService', 'ChannelsService', '$timeout'];
